import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Data } from './helper/datastore';
import { MessagingService } from './services/messaging.service';
import { WebRequestService } from './services/web-request.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'kaakatheeyaM';
  message: any;
  checkDashboard: boolean;
  loginData: any;
  navEnable: any;
  constructor(public service: WebRequestService,private loginDataStore: Data,public messagingService: MessagingService, public route: Router) {
    this.checkDashboard = window.location.href.includes('/dashboard') ? true : false;
  }
  ngOnInit() {
    //this.messagingService.requestPermission();
    //this.messagingService.receiveMessage();
    //this.message = this.messagingService.currentMessage;
    // console.log(this.message);
    // this.navEnable = sessionStorage.getItem('enableNav');
    // this.service.enableNav = JSON.parse(this.navEnable.toLowerCase());
  }
}
